import { PageHeader, Space, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  TableItemDinamico,
  ButtonItem,
  SegmentedItem,
  SwitchItem,
  dineroDisabledMask,
  round10Decimals,
} from "../../../Components/Items";
import {
  EyeOutlined,
  FilePdfOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  SwapOutlined,
  InfoCircleOutlined,
  TagsOutlined,
} from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import ModalMovimientoInventarioPdf from "./ModalMovimientoInventarioPdf/ModalMovimientoInventarioPdf";
import ModalEtiquetasMovimientoInventario from "./ModalEtiquetasMovimientoInventario/ModalEtiquetasMovimientoInventario";
import ModalTiposMovimiento from "./ModalTiposMovimiento/ModalTiposMovimiento";
import { encodeId } from "../../../Components/idEncoder";

moment.locale("es");

const TIPOS_MOVIMIENTO = [
  { value: 101, label: "Entrada por compra", color: "#10b981" },
  { value: 102, label: "Reversa entrada", color: "#f59e0b" },
  { value: 103, label: "Entrada por cambio de insumo", color: "#14b8a6" },
  { value: 201, label: "Salida a centro de costos", color: "#ef4444" },
  { value: 261, label: "Consumo a producción", color: "#8b5cf6" },
  { value: 301, label: "Transferencia entre almacenes", color: "#3b82f6" },
  { value: 311, label: "Cambio ubicación", color: "#06b6d4" },
  { value: 601, label: "Salida por venta", color: "#ec4899" },
  { value: 602, label: "Salida por cambio de insumo", color: "#a855f7" },
  { value: 651, label: "Salida devolución", color: "#f97316" },
  { value: 701, label: "Ajuste positivo inventario", color: "#22c55e" },
  { value: 702, label: "Ajuste negativo inventario", color: "#dc2626" },
];

const DOCUMENTOS_ORIGEN = [
  "Pedido",
  "OrdenDeCompra",
  "Venta",
  "Factura",
  "FacturaSinOrdenDeCompra",
  "Embarque",
  "Cotizacion",
  "Comodato",
  "Consignacion",
  "BajaConsignacion",
  "NotaDeCreditoVenta",
  "NotaDeCreditoCompra",
  "Devolucion",
  "DevolucionCompra",
  "TraspasoEntreAlmacenes",
  "Produccion",
  "RegularizarInventario",
  "ProductosAlCosto",
  "OrdenAgregarInventario",
  "Conteo",
  "FacturaCajaChica",
  "PuntoVenta",
  "Envio",
  "WooCommerce",
  "OnlineStore",
  "AjusteInventario",
  "Otro",
];

const getTipoConfig = (codigo) =>
  TIPOS_MOVIMIENTO.find((t) => t.value === codigo) || {
    value: codigo,
    label: "—",
    color: "#9ca3af",
  };

class MovimientosInventario extends Component {
  tableRef = null;
  state = {
    loading: false,
    todosMovimientos: [],
    totalRecords: 0,
    valor: 5,
    modalPdfVisible: false,
    modalPdfId: null,
    modalPdfFolio: null,
    modalEtiquetasVisible: false,
    modalEtiquetasId: null,
    modalEtiquetasFolio: null,
    modalTiposVisible: false,
    mostrarCostos: false,
    filtroInventariable: 1,
  };

  consultarMovimientos(params = {}) {
    const filtroInventariable = 'filtroInventariable' in params ? params.filtroInventariable : this.state.filtroInventariable;
    this.setState({ loading: true });
    const body = {
      empresaId: this.props.empresaId,
      ...params,
      filtroInventariable,
    };

    axios
      .post("movimientosInventario/selectMovimientosInventario", body, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404 || !res.data) {
          this.setState({
            todosMovimientos: [],
            totalRecords: 0,
            loading: false,
          });
        } else {
          const data = res.data.data || [];
          this.setState({
            loading: false,
            totalRecords: res.data.totalRecords || data.length,
            todosMovimientos: data,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          loading: false,
          todosMovimientos: [],
          totalRecords: 0,
        });
      });
  }

  abrirPdf(record) {
    const folioTipo =
      record.serieTipo || record.folioTipo
        ? `${record.serieTipo ? record.serieTipo + "-" : ""}${record.folioTipo || ""}`
        : null;
    this.setState({
      modalPdfVisible: true,
      modalPdfId: record._id,
      modalPdfFolio: folioTipo || record.serieNumero || record.folio,
    });
  }

  cerrarPdf = () => {
    this.setState({
      modalPdfVisible: false,
      modalPdfId: null,
      modalPdfFolio: null,
    });
  };

  abrirEtiquetas(record) {
    const folioTipo =
      record.serieTipo || record.folioTipo
        ? `${record.serieTipo ? record.serieTipo + "-" : ""}${record.folioTipo || ""}`
        : null;
    this.setState({
      modalEtiquetasVisible: true,
      modalEtiquetasId: record._id,
      modalEtiquetasFolio: folioTipo || record.serieNumero || record.folio,
    });
  }

  cerrarEtiquetas = () => {
    this.setState({
      modalEtiquetasVisible: false,
      modalEtiquetasId: null,
      modalEtiquetasFolio: null,
    });
  };

  render() {
    const { todosMovimientos, totalRecords, loading } = this.state;
    const puedeVerCostos = !!this.props.permisoMostrarCostosMovimientosInventario;
    const costosActivos = puedeVerCostos && this.state.mostrarCostos;
    const puedeVerDetalle = !!this.props.permisoVerMovimientosInventario;

    const filtrosTipos = TIPOS_MOVIMIENTO.map((t) => ({
      text: `${t.value} - ${t.label}`,
      value: t.value,
    }));

    const filtrosES = [
      { text: "Entrada", value: false },
      { text: "Salida", value: true },
    ];

    const columns = [
      {
        title: "Folio",
        dataIndex: "numero",
        key: "numero",
        width: "9%",
        ellipsis: true,
        buscar: "numero",
        render: (value, record) => {
          const folioGeneral =
            `${record.serie ? record.serie + " - " : ""}${record.folio || ""}` ||
            record.serieNumero ||
            "-";
          const folioTipo =
            record.serieTipo || record.folioTipo
              ? `${record.serieTipo ? record.serieTipo + " - " : ""}${record.folioTipo || ""}`
              : null;
          return (
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <span
                style={{
                  fontFamily:
                    "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                  fontSize: 10,
                  color: "#94a3b8",
                  fontWeight: 500,
                }}
              >
                {folioGeneral}
              </span>
              {folioTipo && (
                <span
                  style={{
                    fontFamily:
                      "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                    fontSize: 13,
                    fontWeight: 700,
                    color: "#0f172a",
                    background: "#f1f5f9",
                    padding: "3px 8px",
                    borderRadius: 6,
                    border: "1px solid #e2e8f0",
                    alignSelf: "flex-start",
                  }}
                >
                  {folioTipo}
                </span>
              )}
            </div>
          );
        },
      },
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        width: "11%",
        align: "center",
        sorter: (a, b) =>
          moment(a.fecha).valueOf() - moment(b.fecha).valueOf(),
        render: (value) => {
          if (!value) return "-";
          return (
            <div style={{ lineHeight: 1.2 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: "#0f172a" }}>
                {moment(value).format("DD/MM/YYYY")}
              </div>
              <div style={{ fontSize: 11, color: "#64748b" }}>
                {moment(value).format("HH:mm")}
              </div>
            </div>
          );
        },
      },
      {
        title: "Tipo",
        dataIndex: "tipoMovimiento",
        key: "tipoMovimiento",
        width: "17%",
        filters: filtrosTipos,
        render: (value, record) => {
          const cfg = getTipoConfig(value);
          const desc = record.descripcionTipoMovimiento || cfg.label;
          return (
            <div
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: cfg.color,
                  flexShrink: 0,
                  boxShadow: `0 0 0 3px ${cfg.color}22`,
                }}
              />
              <div style={{ lineHeight: 1.2, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: cfg.color,
                    letterSpacing: 0.3,
                  }}
                >
                  {value}
                </div>
                <div
                  style={{
                    fontSize: 11.5,
                    color: "#475569",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {desc}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        title: "E/S",
        dataIndex: "esSalida",
        key: "esSalida",
        width: "8%",
        align: "center",
        filters: filtrosES,
        render: (value, record) => (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
            {value ? (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                  padding: "3px 9px",
                  borderRadius: 999,
                  background: "#fee2e2",
                  color: "#b91c1c",
                  fontWeight: 600,
                  fontSize: 11,
                  border: "1px solid #fecaca",
                }}
              >
                <ArrowUpOutlined style={{ fontSize: 10 }} />
                Salida
              </span>
            ) : (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                  padding: "3px 9px",
                  borderRadius: 999,
                  background: "#dcfce7",
                  color: "#15803d",
                  fontWeight: 600,
                  fontSize: 11,
                  border: "1px solid #bbf7d0",
                }}
              >
                <ArrowDownOutlined style={{ fontSize: 10 }} />
                Entrada
              </span>
            )}
            {record.esNoInventariable && (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  padding: "2px 7px",
                  borderRadius: 999,
                  background: "#f1f5f9",
                  color: "#64748b",
                  fontWeight: 600,
                  fontSize: 10,
                  border: "1px solid #e2e8f0",
                }}
              >
                No Inv.
              </span>
            )}
          </div>
        ),
      },
      {
        title: "Documento Origen",
        dataIndex: "documentoOrigenTipo",
        key: "documentoOrigenTipo",
        width: "13%",
        ellipsis: true,
        filters: DOCUMENTOS_ORIGEN.map((d) => ({ text: d, value: d })),
        render: (value, record) => {
          if (!value)
            return <span style={{ color: "#cbd5e1" }}>—</span>;
          return (
            <div style={{ lineHeight: 1.25 }}>
              <div
                style={{
                  display: "inline-block",
                  fontSize: 10.5,
                  fontWeight: 700,
                  color: "#1e40af",
                  background: "#dbeafe",
                  padding: "1px 7px",
                  borderRadius: 4,
                  marginBottom: 2,
                  letterSpacing: 0.2,
                }}
              >
                {value}
              </div>
              {record.documentoOrigenSerieFolio && (
                <div
                  style={{
                    fontSize: 11,
                    color: "#475569",
                    fontFamily:
                      "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                  }}
                >
                  {record.documentoOrigenSerieFolio}
                </div>
              )}
            </div>
          );
        },
      },
      {
        title: "Cliente / Proveedor",
        dataIndex: "contraparteNombre",
        key: "contraparteNombre",
        width: "12%",
        ellipsis: true,
        buscar: "contraparteNombre",
        render: (value) =>
          value ? (
            <span style={{ fontSize: 12, color: "#0f172a" }}>{value}</span>
          ) : (
            <span style={{ color: "#cbd5e1" }}>—</span>
          ),
      },
      {
        title: "Concepto",
        dataIndex: "concepto",
        key: "concepto",
        width: "10%",
        ellipsis: true,
        buscar: "concepto",
        render: (value, record) => {
          const v = value || record.referencia;
          return v ? (
            <span style={{ fontSize: 12, color: "#475569" }}>{v}</span>
          ) : (
            <span style={{ color: "#cbd5e1" }}>—</span>
          );
        },
      },
      {
        title: costosActivos ? "Cant. / Costo" : "Cantidad",
        dataIndex: "cantidadTotal",
        key: "cantidadTotal",
        width: "10%",
        align: "right",
        render: (_, record) => (
          <div style={{ textAlign: "right", lineHeight: 1.2 }}>
            <div
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: "#0f172a",
                fontVariantNumeric: "tabular-nums",
              }}
            >
              {round10Decimals(record.cantidadTotal || 0)}
            </div>
            {costosActivos && (
              <div
                style={{
                  fontSize: 11,
                  color: "#64748b",
                  fontVariantNumeric: "tabular-nums",
                }}
              >
                {dineroDisabledMask(record.costoTotal || 0)}
              </div>
            )}
          </div>
        ),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        align: "center",
        render: (value) =>
          value === 0 ? (
            <span
              style={{
                display: "inline-block",
                padding: "3px 10px",
                borderRadius: 999,
                background: "#fef2f2",
                color: "#991b1b",
                fontSize: 11,
                fontWeight: 600,
                border: "1px solid #fecaca",
              }}
            >
              Cancelado
            </span>
          ) : (
            <span
              style={{
                display: "inline-block",
                padding: "3px 10px",
                borderRadius: 999,
                background: "#eff6ff",
                color: "#1e40af",
                fontSize: 11,
                fontWeight: 600,
                border: "1px solid #bfdbfe",
              }}
            >
              Activo
            </span>
          ),
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "8%",
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: "center", padding: "4px" },
        }),
        render: (_, record, index) => (
          <div className="acciones-container">
            {puedeVerDetalle && (
              <Tooltip
                title="Ver detalle"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  key={`ver-${index}`}
                  type="default"
                  size="small"
                  rosa
                  icon={<EyeOutlined />}
                  onClick={() =>
                    this.props.history.push(
                      "/panel/verMovimientoInventario/" +
                        encodeId(String(record._id))
                    )
                  }
                />
              </Tooltip>
            )}
            <Tooltip
              title="Vista PDF"
              placement="top"
              overlayInnerStyle={{
                fontSize: "10px",
                padding: "1px 5px",
                minHeight: "auto",
              }}
            >
              <ButtonItem
                key={`pdf-${index}`}
                type="default"
                size="small"
                lila
                icon={<FilePdfOutlined />}
                onClick={() => this.abrirPdf(record)}
              />
            </Tooltip>
            {!record.esSalida && (
              <Tooltip
                title="Imprimir etiquetas"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  key={`etq-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<TagsOutlined />}
                  onClick={() => this.abrirEtiquetas(record)}
                />
              </Tooltip>
            )}
          </div>
        ),
      },
    ];

    return (
      <>
        <PageHeader
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  background:
                    "linear-gradient(135deg, #00BFD6 0%, #0891b2 100%)",
                  color: "white",
                  boxShadow: "0 4px 12px rgba(0, 191, 214, 0.25)",
                }}
              >
                <SwapOutlined style={{ fontSize: 18 }} />
              </span>
              <div style={{ lineHeight: 1.2 }}>
                <div style={{ fontSize: 18, fontWeight: 600, color: "#0f172a" }}>
                  Movimientos de Inventario
                </div>
                <div style={{ fontSize: 12, color: "#64748b", fontWeight: 400 }}>
                  Historial de entradas, salidas y ajustes
                </div>
              </div>
            </div>
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
            borderRadius: 6,
          }}
          extra={
            <Space>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Inventariable", value: 1 },
                    { label: "No Inventariable", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: this.state.valor, filtroInventariable: value });
                    }
                    this.setState({ filtroInventariable: value });
                  }}
                  value={this.state.filtroInventariable}
                />
              )}
              <Tooltip
                title={
                  puedeVerCostos
                    ? "Mostrar costos en tabla, detalle y PDF"
                    : "No tienes permiso para ver costos"
                }
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                  <span style={{ fontSize: 12, color: "#475569" }}>
                    Mostrar costos
                  </span>
                  <SwitchItem
                    checked={costosActivos}
                    disabled={!puedeVerCostos}
                    onChange={(checked) =>
                      this.setState({ mostrarCostos: checked })
                    }
                  />
                </span>
              </Tooltip>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Activos", value: 1 },
                    { label: "Cancelados", value: 0 },
                    { label: "Todos", value: 5 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value, filtroInventariable: this.state.filtroInventariable });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <Tooltip
                title="Ver tipos de movimiento"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  blanco
                  icon={<InfoCircleOutlined />}
                  onClick={() =>
                    this.setState({ modalTiposVisible: true })
                  }
                >
                  Tipos
                </ButtonItem>
              </Tooltip>
            </Space>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          totalRecords={totalRecords}
          loading={loading}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarMovimientos.bind(this)}
          size="small"
          dataSource={todosMovimientos}
          columns={columns}
          pagination={false}
          onRow={(record) => ({
            onDoubleClick: () => {
              if (!puedeVerDetalle) return;
              this.props.history.push(
                "/panel/verMovimientoInventario/" +
                  encodeId(String(record._id))
              );
            },
            style: { cursor: puedeVerDetalle ? "pointer" : "default" },
          })}
          filterStorageKey={
            "movimientosInventarioFiltrosTabla" + this.props.empresaId
          }
          setValor={(valor) => this.setState({ valor })}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          valorDefault={5}
          valorTextoDefault={""}
          locale={{ emptyText: "No se encontraron movimientos de inventario" }}
        />
        <ModalMovimientoInventarioPdf
          visible={this.state.modalPdfVisible}
          movimientoId={this.state.modalPdfId}
          movimientoFolio={this.state.modalPdfFolio}
          mostrarCostos={costosActivos}
          onCancel={this.cerrarPdf}
        />
        <ModalEtiquetasMovimientoInventario
          visible={this.state.modalEtiquetasVisible}
          movimientoId={this.state.modalEtiquetasId}
          movimientoFolio={this.state.modalEtiquetasFolio}
          onCancel={this.cerrarEtiquetas}
        />
        <ModalTiposMovimiento
          visible={this.state.modalTiposVisible}
          onCancel={() => this.setState({ modalTiposVisible: false })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoVerMovimientosInventario:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "69fe8f1bd4eff74041f388f1"
    )?.activado,
  permisoMostrarCostosMovimientosInventario:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "69fe8f69d4eff74041f388f2"
    )?.activado,
});

export default connect(mapStateToProps)(MovimientosInventario);
